var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var FormulaValidationInfo_1;
import { JSON, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { ToolValidationState } from './validation/toolValidationResult';
import { formulaValidationInfoSchemaValidation } from '../validations.generated';
export var FormulaValidationError;
(function (FormulaValidationError) {
    FormulaValidationError["SYNTAX_ERROR"] = "syntax_error";
    FormulaValidationError["MISSING_ARGUMENTS"] = "missing_arguments";
    FormulaValidationError["TOO_MANY_ARGUMENTS"] = "too_many_arguments";
    FormulaValidationError["INVALID_ARGUMENT"] = "invalid_argument";
    FormulaValidationError["INVALID_DATA_FORMAT"] = "invalid_data_format";
    FormulaValidationError["INVALID_SOURCE"] = "invalid_source";
    FormulaValidationError["UNSUPPORTED_DATA_TYPE"] = "unsupported_data_type";
    FormulaValidationError["FUNCTION_NOT_EXIST"] = "function_not_exist";
    FormulaValidationError["IMPLICIT"] = "implicit";
    FormulaValidationError["CASE_TOOL_NOT_CONDITION"] = "case_tool_not_condition";
    FormulaValidationError["OTHER"] = "other";
})(FormulaValidationError || (FormulaValidationError = {}));
export const formulaValidationInfoSchema = {
    $id: 'urn:wisepipe-common-pipe:FormulaValidationInfo',
    type: 'object',
    properties: {
        validationState: { type: 'number', enum: Object.values(ToolValidationState) },
        errorType: { type: 'string', enum: Object.values(FormulaValidationError) },
        functionName: { type: 'string' },
        parameterName: { type: 'string' }
    },
    required: ['validationState']
};
let FormulaValidationInfo = FormulaValidationInfo_1 = class FormulaValidationInfo {
    constructor(validationState, comment, errorType, functionName) {
        this.validationState = validationState;
        if (comment !== undefined)
            this.comment = comment;
        if (errorType !== undefined)
            this.errorType = errorType;
        if (functionName !== undefined)
            this.functionName = functionName;
        JSON.validate(this, FormulaValidationInfo_1);
    }
};
FormulaValidationInfo = FormulaValidationInfo_1 = __decorate([
    JsonSchemaV2(formulaValidationInfoSchema, formulaValidationInfoSchemaValidation)
], FormulaValidationInfo);
export { FormulaValidationInfo };
//# sourceMappingURL=formulaValidationInfo.js.map